/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'slots-videoconference': {
    width: 11,
    height: 10,
    viewBox: '0 0 11 10',
    data: '<path pid="0" d="M2.912 5.615L.667 3.985V9.2l2.245-1.63v.652c0 .521.417.978.963.978H9.97a.973.973 0 00.962-.978V4.963c0-.554-.417-.978-.962-.978H3.875c-.546 0-.963.424-.963.978v.652zm4.492-3.748c0 .81.647 1.466 1.444 1.466.797 0 1.444-.656 1.444-1.466 0-.81-.647-1.467-1.444-1.467-.797 0-1.444.657-1.444 1.467zm-3.85 0c0 .81.646 1.466 1.444 1.466.797 0 1.444-.656 1.444-1.466C6.442 1.057 5.795.4 4.998.4c-.798 0-1.444.657-1.444 1.467z" _fill="#FFF" fill-rule="evenodd"/>'
  }
})
